// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".lending-slot-unavailable {\n  text-decoration: line-through;\n  opacity: 0.6;\n}\n[dir=ltr] .clean-bootstrap-margin {\n  margin-right: 0.25rem !important;\n}\n[dir=rtl] .clean-bootstrap-margin {\n  margin-left: 0.25rem !important;\n}", ""]);
// Exports
module.exports = exports;
